export const defaultState = {
	selectedProcessingId: '-1',
	selectedCarrierId: '-1',
	selectedDate: '',
	selectedSlot: '-1',
	allCarriers: {},
	allDates: [],
	allSlots: {},
	initialized: false,
	isRequired: false,
	isUpdate: false,
	currentRateId: '',
};
